import type { TicketRequestSubcategoryI } from 'declarations/interfaces/ticketRequestSubcategories';

import { get } from './api';

export const getTicketRequestSubCategories = async (
  oemFamilyId?: string
): Promise<TicketRequestSubcategoryI[]> => {
  const response = await get<TicketRequestSubcategoryI[]>('/tickets/sub-categories', {
    ...(oemFamilyId ? { oemFamilyId } : {}),
  });

  return response.data ?? [];
};

export const getTicketRequestSubCategoriesByCategoryId = async (
  categoryId: number,
  oemFamilyId?: string
): Promise<TicketRequestSubcategoryI[]> => {
  const response = await get<TicketRequestSubcategoryI[]>(
    `/ticket-request-categories/${categoryId}/sub-categories`,
    { ...(oemFamilyId ? { oemFamilyId } : {}) }
  );

  return response.data ?? [];
};
